<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.7642 18.272C17.579 18.368 17.4285 18.368 17.4285 18.368C17.4285 18.368 16.4373 18.48 15.4061 18.064C15.4061 18.064 15.9496 18.12 16.1655 18.08C16.1655 18.08 14.8465 17.568 14.6227 17.432C14.6227 17.432 14.7426 17.456 14.9744 17.392C14.9744 17.392 11.3373 15.568 9.92246 13.504L10.0903 13.528C10.0903 13.528 10.0104 13.304 9.84253 13.272C9.67466 13.24 9.33094 12.912 9.33094 12.912C9.33094 12.912 6.64508 10.064 5.98961 7.592L6.18945 7.656C6.18945 7.656 5.58993 6.936 5.67786 6.04C5.67786 6.04 8.81135 5.36 14.0072 9.888C14.0072 9.888 14.7426 11.496 15.1902 11.776L14.8625 10.408C14.8625 10.408 18.1958 14.184 18.6994 15.896C18.6994 15.896 18.5556 15.432 18.6755 15.08C18.8034 14.728 19.0192 16.72 19.0192 16.72C19.0192 16.72 19.195 15.776 19.4908 15.512C19.4908 15.512 19.0352 17.104 19.203 17.744L20.3701 18.744C22.0008 16.968 23 14.6 23 12C22.984 6.48 18.5076 2 12.992 2C7.47642 2 3 6.48 3 12C3 17.52 7.47642 22 12.992 22C15.7578 22 18.2598 20.872 20.0663 19.056C19.8665 18.928 18.8513 18.264 18.7074 18.152C18.7074 18.152 18.1878 18 17.7642 18.272Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgAISESIcon',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>